import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
// import CustomButtonWithStroke from './../../components/auth/AuthButton';
import CustomButton from './../../components/CustomButton';
import '../../styles/Home.css';
import Typography from '../../components/Typography';

const Home = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  useEffect(() => {
    const token = searchParams.get('token');
    const userInfo = searchParams.get('userInfo');
    if (token && userInfo) {
      localStorage.setItem('token', token);
      localStorage.setItem('userInfo', userInfo);
      navigate('/dashboard', { replace: true });
    }
  }, [searchParams, navigate]);

  return (
    <div className="home-container">
      <Typography text={'Welcome to ASH CAPITAL'} className='font-bold' family={'Supply'} size={'30px'} weight={500} lineheight={'170%'} transform={'uppercase'} />
      <Typography text={'Manage your investments, milestones, support tickets, and referrals with ease.'} className='mb-5' size={'16px'} weight={400} lineheight={'170%'} />
      <CustomButton className='max-w-xs' onClick={() => navigate('/login')} text={'Get Start'} />
    </div>
  );
};

export default Home;